import { useTranslation } from "react-i18next";

import {
  CREDIT_BEHAVIOUR_COLUMNS,
  CreditBehaviourDataRow
} from "@/Pages/Dashboard/LeftSide/types";
import { ACTIVITY_STATUS } from "@/shared";

const useCreditBehaviourData = () => {
  const { t } = useTranslation();

  const columns = [
    CREDIT_BEHAVIOUR_COLUMNS.VehicleStatus,
    CREDIT_BEHAVIOUR_COLUMNS.Device,
    CREDIT_BEHAVIOUR_COLUMNS.CreditBehaviour
  ];

  const fullTranslatedString = (stringKey: string) =>
    t(`Dashboard##how credits work##bottom content##table##body##${stringKey}`);

  const dataRows: CreditBehaviourDataRow[] = [
    {
      vehicleStatus: ACTIVITY_STATUS.Active,
      device: fullTranslatedString("newly assigned"),
      creditBehaviour: fullTranslatedString("newly assigned behaviour")
    },
    {
      vehicleStatus: ACTIVITY_STATUS.Active,
      device: fullTranslatedString("replaced vin known"),
      creditBehaviour: fullTranslatedString("replaced vin known behaviour")
    },
    {
      vehicleStatus: ACTIVITY_STATUS.Active,
      device: fullTranslatedString("none"),
      creditBehaviour: fullTranslatedString("none behaviour")
    },
    {
      vehicleStatus: ACTIVITY_STATUS.Deactivated,
      device: fullTranslatedString("any"),
      creditBehaviour: fullTranslatedString("any behaviour")
    }
  ];

  return {
    columns,
    dataRows
  };
};

export default useCreditBehaviourData;
